
    // featured collection
    $(document).ready(function(){
      featured_collection();
    });
    document.addEventListener("shopify:section:load", function() {
      featured_collection(); 
    })  
    function featured_collection(){
      $('.featured-collection-items').slick({
          arrows:false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: true,
          dots: true,
          responsive: [
            {
              breakpoint: 767,
              settings: 'unslick',
            }
          ]
      });
    }
    
    // product slider 
    $(document).ready(function(){
      product_slider();
    });
    document.addEventListener("shopify:section:load", function() {
      product_slider(); 
    })  
    function product_slider(){
      $('.product-slider-items').slick({
          arrows:true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          prevArrow:"<span class='arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
          nextArrow:"<span class='arrow-next'><img src='"+ arrow +"' alt='arrow'></span>",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                  slidesToShow: 2,
                  arrows:false
              }
              
            }
          ]
      });
    }
    
    // review slider 
    $(document).ready(function(){
        review_slider();
    });
    document.addEventListener("shopify:section:load", function() {
      review_slider(); 
    })  
    function review_slider(){
      $('.custom-review-items').slick({
          arrows:true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          prevArrow:"<span class='arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
          nextArrow:"<span class='arrow-next'><img src='"+ arrow +"' alt='arrow'></span>",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                  slidesToShow: 1,
                  arrows:false
              }
              
            }
          ]
      })
      .on('setPosition', function (event, slick) {
          slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
    }
    

    // review slider 
    // if($(window).width() < 481){
    //     $('.custom-review-items').slick({
    //         arrows:false,
    //         speed: 300,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         mobileFirst: true,
    //         infinite: true,
    //         dots: false,
    //         responsive: [
    //         {
    //             breakpoint: 767,
    //             settings: 'unslick',
    //         }
    //         ]
    //     })
    //     .on('setPosition', function (event, slick) {
    //         slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    //     });
    // }

$(document).ready(function(){
    // header sticky bg color 
    $(window).scroll(function(){
      if ($(this).scrollTop() > 140) {
         $('.header-transparent').addClass('header-bg-white');
      } else {
         $('.header-transparent').removeClass('header-bg-white');
      }
    });
    // header  mobile menu 
    $('.icon-hamburger').on('click', function(){
      $('.mobile-drawer').addClass('active');
      $('#menu-drawer').addClass('show');
    })
    $('span.icon-close').on('click', function(){
      $('.mobile-drawer').removeClass('active');
      $('#menu-drawer').removeClass('show');

    })
    // collection text button 
    $('.collection-description_buttons').on('click', function(){
      $('.collection-description_excerpt, .collection-description__read-more, .collection-description_content, .collection-description__read-less').toggleClass('hidden');
      $(this).toggleClass('active');
    })

    $('.article-image-slide').slick({
        arrows:false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                },
            }
          ]
    });
})